<template src="./resi.html"></template>

<script>
import {
  get_elencoResi,
  get_elencoOmaggi,
  set_ordineVisionato,
} from "@/api/api.ordini.js";

import DialogFile from "@/components/dialog/file/DialogFile.vue";

export default {
  components: {
    DialogFile,
  },

  data: () => ({
    attesa: false,
    //filtri
    startYear: 2022,
    annoSel: "",
    elencoAnni: [],
    tipologia: "Da visionare",
    elencoTipi: ["Da visionare", "Visionati"],

    repartoSel: "",
    elencoReparti: [
      "",
      "Magazzino",
      "Spedizione",
      "Imballaggio",
      "Presse & Pantografi",
      "Ufficio",
      "Cliente",
      "Fornitore",
      "Verniciatura",
      "Altro",
    ],

    search: "",
    tabs: 0,

    //dati
    elencoResi: [],
    //headers
    headersResi: [],
    ordDesc: true,
    ordColumn: "Num_Ord",

    elencoOmaggi: [],

    dialogFile: false,
    //elenco dei file da visualizzare nella dialog
    elencoFile: [],

    dialogImg: false,
    imgSelected: "",

    selectedRow: {},
    page: 1,
    pageCount: 0,
    itemsPerPage: 999,
  }),
  methods: {
    async caricaDati() {
      this.attesa = true;
      let par = "";

      //aggiungo i filtri per admin/agente/agente capo
      if (this.role == "Admin") {
        par = "" + this.annoSel;
      } else if (this.role == "Agente" || this.role == "AgenteCapo") {
        par = this.$store.getters["user/getCodice"] + "/" + this.annoSel;
      }
      if (
        this.userSwitch.Codice != undefined &&
        this.userSwitch.Codice != null
      ) {
        par = this.userSwitch.Codice + "/" + this.annoSel;
      }

      if (this.tabs == "resi") {
        let res = await get_elencoResi(par);
        this.elencoResi = res.data;
      } else if (this.tabs == "omaggi") {
        let res = await get_elencoOmaggi(par);
        this.elencoOmaggi = res.data;
      }
      this.attesa = false;
    },

    //#region Headers tabella
    caricaHeaders() {
      this.headersResi = [
        {
          text: "N. Ordine",
          value: "Num_Ord",
          class: "ml-0 pl-0",
          sortable: true,
          style: "cursor: pointer; text-align: left;",
        },
        {
          text: "Immagini",
          value: "Immagini",
          class: "ml-0 pl-0",
          style: " text-align: left;",
          sortable: false,
        },

        {
          text: "Data di caricamento",
          value: "Data_Ord",
          class: "ml-0 pl-0",
          sortable: true,
          style: "cursor: pointer; text-align: left;",
        },
        {
          text: "Cliente",
          value: "CLRAGSOC",
          class: "ml-0 pl-0",
          style: "min-width: 180px !important; cursor: pointer; text-align: left;",
          sortable: true,
        },
        {
          text: "Rif.",
          value: "Riferimento",
          class: "ml-0 pl-0",
          sortable: true,
          style: "cursor: pointer; text-align: left;",
        },

      ];

      if (this.role == "Admin") {
        this.headersResi.splice(1, 0,
          {
            text: "Modulo",
            value: "Modulo",
            class: "ml-0 pl-0",
            style: "text-align: left;",
            sortable: false,
          });

        this.headersResi.splice(
          6,
          0,
          { text: "Pag", value: "CodPag", class: "ml-0 pl-0", sortable: true },
          {
            text: "Reparto",
            value: "Reparti",
            class: "ml-0 pl-0",
            style: "max-width: 100px !important; cursor: pointer; text-align: left;",
            sortable: true,
          },
          {
            text: "Totale imponibile",
            value: "TotImponibile",
            width: "60",
            class: "ml-0 pl-0",
            style: "cursor: pointer; text-align: left;",
            sortable: true,
          },
          {
            text: "Note Conto",
            value: "NoteConto",
            class: "ml-0 pl-0",
            style: "text-align: left;",
            sortable: false,
          },
        );
      }

      if (this.tabs == "resi" && this.role == "Admin")
        this.headersResi.splice(0, 0, {
          text: "Visionati",
          value: "Visionati",
          class: "ml-0 pl-0",
          style: "text-align: left;",
        });
    },

    //ordinamento tabella
    customSort(items, index, isDesc) {
      return items;
    },

    async changeSort(column) {
      let result = await this.headersResi.filter((obj) => {
        return obj.value === column;
      });

      if (result == null || result == undefined || result[0].sortable == false)
        return;

      if (column != this.ordColumn) {
        this.ordColumn = column;
        this.ordDesc = true;
      } else {
        this.ordDesc = !this.ordDesc;
      }
      //let elenco = this.getTabellaResi();
      let thisP = this;
      switch (column) {
        case "Num_Ord":
          this.elencoResi.sort(function (a, b) {
            return thisP.ordinaValori(a.Num_Ord, b.Num_Ord);
          });
          this.elencoOmaggi.sort(function (a, b) {
            return thisP.ordinaValori(a.Num_Ord, b.Num_Ord);
          });
          break;
        case "Data_Ord":
          this.elencoResi = await this.ordinaDate(this.elencoResi);
          this.elencoOmaggi = await this.ordinaDate(this.elencoOmaggi);
          break;
        case "CLRAGSOC":
          this.elencoResi.sort(function (a, b) {
            return thisP.ordinaValori(a.CLRAGSOC, b.CLRAGSOC);
          });
          this.elencoOmaggi.sort(function (a, b) {
            return thisP.ordinaValori(a.CLRAGSOC, b.CLRAGSOC);
          });
          break;
        case "Riferimento":
          this.elencoResi.sort(function (a, b) {
            return thisP.ordinaValori(a.Riferimento, b.Riferimento);
          });
          this.elencoOmaggi.sort(function (a, b) {
            return thisP.ordinaValori(a.Riferimento, b.Riferimento);
          });
          break;
        case "CodPag":
          this.elencoResi.sort(function (a, b) {
            return thisP.ordinaValori(a.CodPag, b.CodPag);
          });
          this.elencoOmaggi.sort(function (a, b) {
            return thisP.ordinaValori(a.CodPag, b.CodPag);
          });
          break;
        case "Reparti":
          this.elencoResi.sort(function (a, b) {
            return thisP.ordinaValori(a.Reparti, b.Reparti);
          });
          this.elencoOmaggi.sort(function (a, b) {
            return thisP.ordinaValori(a.Reparti, b.Reparti);
          });
          break;
        case "TotImponibile":
          this.elencoResi.sort(function (a, b) {
            return thisP.ordinaValori(a.TotImponibile, b.TotImponibile);
          });
          this.elencoOmaggi.sort(function (a, b) {
            return thisP.ordinaValori(a.TotImponibile, b.TotImponibile);
          });
          break;
      }
    },

    ordinaValori(a, b) {
      if (this.ordDesc) return a > b ? -1 : a < b ? 1 : 0;
      else return a < b ? -1 : a > b ? 1 : 0;
    },

    async ordinaDate(arr) {
      let thiss = this;
      await arr.sort(function (a, b) {
        a = new Date(a.Data_Ord);
        b = new Date(b.Data_Ord);
        return thiss.ordinaValori(a, b);
      });
      return arr;
    },

    //#endregion
    formattaData(data) {
      return this.$i2kFunctions.formatISODate(data);
    },

    refresh() {
      this.caricaHeaders();
      this.caricaDati();
    },

    getTabellaResi() {
      let items = this.getElencoResi();
      return this.getElencoConTotale(items);
    },

    getElencoResi() {
      if (this.role == "Agente" || this.role == "AgenteCapo")
        return this.elencoResi;
      let vis = false;
      if (this.tipologia == "Visionati" || this.tipologia == "Storico")
        vis = true;
      let rep = this.repartoSel.toLowerCase();
      if (this.elencoResi != undefined && this.elencoResi != null)
        return this.elencoResi.filter(function (x) {
          return (x.Visionato == vis && x.Reparti.includes(rep)) || x.CLRAGSOC == "ZZZZZ"
        });
      else return [];
    },

    getTabellaOmaggi() {
      let items = this.getElencoOmaggi();
      return this.getElencoConTotale(items);
    },

    getElencoConTotale(items) {
      let somma = 0, num = 0;
      items.forEach(el => {
        if (el.CLRAGSOC != "ZZZZZ") {
          somma += el.TotImponibile;
          num++;
        }
      });

      let newObj = { TotImponibile: parseFloat(somma).toFixed(2), Num_Ord: num, CLRAGSOC: "ZZZZZ" };
      let obj = items.filter(x => x.CLRAGSOC == "ZZZZZ");
      let index = items.indexOf(obj[0]);
      if (index != -1)
        items[index] = newObj;

      return items;
    },

    getElencoOmaggi() {
      if (this.role != "Admin")
        return [];

      let vis = false;
      if (this.tipologia == "Visionati" || this.tipologia == "Storico")
        vis = true;
      if (this.elencoOmaggi != undefined && this.elencoOmaggi != null)
        return this.elencoOmaggi.filter(function (x) {
          return x.Visionato == vis;
        });
      else return [];

    },

    //#region Documenti Resi
    apriDocumento(file) {
      window.open(file, "_blank");
    },

    apriDialogFile(elenco, tipo) {
      //se c'e' solo un file pdf lo apro altrimenti visualizzo la dialog di scelta
      if (tipo == "pdf" && elenco.length == 1) {
        this.apriDocumento(elenco[0].Percorso);
        return;
      }
      this.dialogFile = true;
      this.elencoFile = elenco;
    },

    chiudiDialogFile() {
      this.dialogFile = false;
    },

    //#endregion

    stileRigaTabella(el) {
      if (el.CLRAGSOC == "ZZZZZ") return;
      if (el.Visionato) {
        return "background-color: #f2e6ff;";
      }
      if (el.Num_Ord == this.selectedRow.Num_Ord)
        return "background-color: #D4D4D4";
    },

    async spuntaOrdine(el) {
      if (el.CLRAGSOC == "ZZZZZ") return;
      if (this.role != "Admin") return;
      let par = {
        Id: el.Id,
        Visionato: el.Visionato,
        Tipo_Documento: el.Tipo_Documento,
      };
      let res = await set_ordineVisionato(par);
      if (res.data == "OK") this.refresh();
      else this.$toast.warning("Errore! Impossibile visionare l'ordine");
    },

    selezionaRiga(row) {
      this.selectedRow = row;
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(400);

    this.annoSel = this.$i2kFunctions.getYear();
    for (let i = this.startYear; i <= this.annoSel; i++)
      this.elencoAnni.push(i);
    this.refresh();

    if (this.elencoFile == null) this.elencoFile = [];

    //sugli agenti devo cambiare il testo nella select
    /* if (this.role == "Agente" || this.role == "AgenteCapo") {
      this.tipologia = "Da consegnare";
      this.elencoTipi = ["Da consegnare", "Storico"];
    } */
  },

  watch: {
    tabs() {
      this.refresh();
    },

    userSwitch() {
      this.refresh();
    },
  },

  computed: {
    role() {
      return this.$store.getters["user/getRole"];
    },

    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
  },
};
</script>

<style scoped>
.totale {
  font-weight: bold !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  /*font-size: 1.1em;*/
}
</style>